import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "layout" */ '../components/layout/Layout.vue'),
    redirect: '/home',
    meta: {
      requiresAuth: false
    },
    children:[
      {
        path: '/home',
        name: 'Home',
        component: () => import(/* webpackChunkName: "home" */ '../views/home/home.vue'),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: '/find',
        name: 'Find',
        component: () => import(/* webpackChunkName: "find" */ '../views/match/find.vue'),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: '/order',
        name: 'Order',
        component: () => import(/* webpackChunkName: "order" */ '../views/order/order.vue'),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: '/orderGrabbing',
        name: 'OrderGrabbing',
        component: () => import(/* webpackChunkName: "orderGrabbing" */ '../views/orderGrabbing/orderGrabbing.vue'),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: '/profile',
        name: 'Profile',
        component: () => import(/* webpackChunkName: "profile" */ '../views/profile/Profile.vue'),
        meta: {
          requiresAuth: false
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isLogin = store.getters['user/isLogin']
  
  if (to.meta.requiresAuth && !isLogin) {
    // 需要登录但未登录，跳转到登录页
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
})

export default router

